define.alias("shared/components/shared/carousel/indicators", "preview-grid/components/shared/carousel/indicators");